import { render, staticRenderFns } from "./PersonalQuestion.vue?vue&type=template&id=17bfd440&scoped=true"
import script from "./PersonalQuestion.vue?vue&type=script&lang=js"
export * from "./PersonalQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bfd440",
  null
  
)

export default component.exports